import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import UploadFile from './UploadFile'
import FileManagement from './FileManagement/FileManagement'
import FileInfo from './FileManagement/FileInfo'
import ReportList from './Reports/ReportList';

export default function ICAAP({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/upload-file`} component={UploadFile} />
        <Route path={`${match.url}/reports`} component={ReportList} />
        <Route path={`${match.url}/file-management`} component={FileManagement} />
        <Route path={`${match.url}/file-info/:report_date/:file_name`} component={FileInfo} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/pages/ICAAP/index.js